/* Copyright 2016-2022
   Kabandy
   Author: Jonathan Boosten
 */

export module ProjectDataModel {
    export enum EErrorMsg {
        Create = "Can't create project"
    }

    export enum ECreateErrorMsg {
        ContractNotFound = "Contract not found"
    }

    export interface IProject {
        id: string;
        userId: string;
        imageLocation: string;
        content: any;
    }

    export interface ICreateInfo {
        userId: string;
        projectId?: string;
        content?: any;
    }

    export interface IUpdateInfo {
        projectId: string;
        name?: string;
        imageLocation?: string;
        isCustomImage?: boolean;
    }

    export interface IDeleteResponse {
        projectId: string;
        storageCount: number;
        firestoreCount: number;
        datastoreCount: number;
        accessesCount: number;
        accessPeriodsCount: number;
    }

    export interface ISizeOfResponse {
        projectId: string;
        size: number;
        entitiesCount: number;
    }
}
